import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import formatCurrency from 'rebook/apps/utils/text/formatCurrency';
import { formatDateTime } from 'rebook/apps/utils/datetime';

import DateView from './components/DateView';
import ItemView from './components/ItemView';
import StatusView from './components/StatusView';
import TypeView from './components/TypeView';
import PeriodView from './components/PeriodView';
import PaymentView from './components/PaymentView';
import Accordion from './components/Accordion/Accordion';

import styles from './style.scss';


const PaymentListPaymentData = ({ payment }) => {
  const columnsBodyList = payment.map((item) => {
    const isRentedProduct = item.rent_product;
    return {
      item: isRentedProduct ? isRentedProduct.book : item.subscription_type,
      date: {
        created: formatDateTime(item.created, 'D.MM.YYYY (H:mm)'),
        payedTill: isRentedProduct ? item.rent_payed_till : (item.pro_payed_till || item.standard_payed_till),
      },
      type: isRentedProduct ? 'rent' : item.subscription_type,
      period: {
        rentDays: isRentedProduct && item.rent_product.days,
        days: item.subscription_days,
        month: item.subscription_months,
      },
      cost: formatCurrency(item.amount, 'RUB'),
      payment: item.method.slug,
      status: item.status,
      recipe: item.receipt_ofd_link,
    };
  });

  const columnsHeaderList = [
    'Подписка / Книга',
    'Дата',
    'Доступ',
    'Период',
    'Стоимость',
    'Оплата',
    'Статус',
    'Чек',
  ];

  return (
    <div className="jest-payment-data">
      <div className={styles.wrapperDesktop}>
        <div className={classNames(styles.row, styles.rowTop)}>
          {columnsHeaderList.map((item, index) => <div key={index} className={styles.column}>{item}</div>)}
        </div>
        {columnsBodyList.map((item, index) => (
          <div className={classNames(styles.row, styles.rowBody)} key={index}>
            <div className={styles.column}><ItemView item={item.item} /></div>
            <div className={styles.column}><DateView date={item.date.created} payedTill={item.date.payedTill} /></div>
            <div className={styles.column}><TypeView type={item.type} /></div>
            <div className={styles.column}><PeriodView date={item.period} /></div>
            <div className={styles.column}>{item.cost}</div>
            <div className={styles.column}><PaymentView type={item.payment} /></div>
            <div className={styles.column}><StatusView status={item.status} /></div>
            <div className={styles.column}>
              {item.recipe && <a href={item.recipe} className={styles.link}>Кассовый чек</a>}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.wrapperMobile}>
        <Accordion data={columnsBodyList} />
      </div>
    </div>
  );
};

PaymentListPaymentData.propTypes = {
  amount: PropTypes.string,
};

export default PaymentListPaymentData;
